import React, { useEffect, useState } from 'react';
import {
  Backdrop,
  Box,
  Button,
  Fade,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
  InputAdornment,
  CircularProgress,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import dayjs from 'dayjs';
import UpdateManagement from '../../api/management/update_management.ts';
import CreateCredit from '../../api/credit/new_credit.ts';
import currencyFormatter from '../../services/currencyFormater.js';
import { CustomerCreditErrorAlert, CustomerCreditSuccessAlert } from '../alert/customerAlert.js';
import { useSelector } from 'react-redux';

const StyledBackdrop = (props) => (
  <Backdrop {...props} sx={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }} />
);

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '95%', sm: '80%', md: '70%', lg: '60%' },
  maxHeight: { xs: '85dvh', md: '90vh' },
  overflowY: 'auto',
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  p: { xs: 2, md: 4 },
  outline: 'none',
  userSelect: 'none',
  WebkitUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
};

const Credit = ({ credit, open, onClose, action }) => {
  const [loading, setLoading] = useState(false);


  const cities = useSelector((state) => state.cities.data);
  const dataType = useSelector((state) => state.dataTypes.data);
  const campaign = useSelector((state) => state.campaign.data);
  const disbursementOffice = useSelector((state) => state.disbursementOffice.data);
  const offices = useSelector((state) => state.offices.data);

  const [formData, setFormData] = useState({
    approved_amount: 0,
    interest_rate: 0.1,
    campaign_id: 0,
    credit_id: credit?.credit_id ? credit?.credit_id : 0,
    current_balance: 0,
    customer_id: 0,
    defined_quota: 0,
    disburse_value: 0,
    start_date: "",
    prepaid_capital_balance: 0,
    aval: 0,
    research: 0,
    prem_per_million: 0,
    payment_capacity: 0,
    aval_amount: 0,
    credit_study: 0,
    document: 0,
    management_id: 0,
    name_credit: '',
    observation: '',
    office_id: 0,
    period: 0,
    status_id: 0,
    date_management: "",
    disbursement_office_id: 0,
  });

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    if (credit && open) {
      if (action === 'newCredit') {

        setFormData(prev => ({
          approved_amount: 0,
          interest_rate: 0.1,
          campaign_id: 0,
          credit_id: 0,
          current_balance: 0,
          customer_id: 0,
          defined_quota: 0,
          disburse_value: 0,
          start_date: "",
          prepaid_capital_balance: 0,
          aval: 0,
          research: 0,
          prem_per_million: 0,
          payment_capacity: 0,
          aval_amount: 0,
          credit_study: 0,
          document: 0,
          management_id: 0,
          name_credit: '',
          observation: '',
          office_id: 0,
          period: 0,
          status_id: 0,
          date_management: dayjs(),
          disbursement_office_id: 0,
        }));
      } else if (action === 'editCredit') {
        setFormData({
          ...credit.credit,
          approved_amount: credit.credit?.approved_amount,
          interest_rate: credit.credit?.interest_rate,
          campaign_id: credit.credit?.campaign_id,
          credit_id: credit?.credit_id,
          current_balance: credit.credit?.current_balance,
          customer_id: credit.credit?.customer_id || credit?.customer_id,
          defined_quota: credit.credit?.defined_quota,
          disburse_value: credit.credit?.disburse_value,
          start_date: credit.credit?.start_date ? dayjs(credit.credit.start_date) : null,
          prepaid_capital_balance: credit.credit?.prepaid_capital_balance,
          aval: credit.credit?.aval,
          research: credit.credit?.research,
          prem_per_million: credit.credit?.prem_per_million,
          payment_capacity: credit.credit?.payment_capacity,
          aval_amount: credit.credit?.aval_amount,
          credit_study: credit.credit?.credit_study,
          document: credit?.document,
          management_id: credit?.management_id,
          name_credit: credit.credit?.name_credit,
          observation: credit?.observation,
          office_id: credit.credit?.office_id || credit?.office_id || credit?.id_office,
          period: credit.credit?.period,
          date_management: credit?.date ? dayjs(credit.date) : null,
          status_id: credit.credit?.credit_status,
          disbursement_office_id: credit.credit?.disbursement_office_id,
        });
      }
    }
  }, [credit, open, action, cities]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  const handleUpdate = async () => {
    setLoading(true);
    try {
      if (action === 'editCredit') {
        const update = await UpdateManagement({
          "management_id": formData.management_id,
          "observation": formData.observation,
          "credit_id": formData.credit_id,
          "date_management": formData.date_management
        });
        if (update.status === 200) {
          handleClose();
          CustomerCreditSuccessAlert('Crédito actualizado correctamente', '#1976d2');
        } else {
          handleClose();
          CustomerCreditErrorAlert('Ocurrio un error al actualizar el crédito', '#ff0000');
        }
      }

      if (action === 'newCredit') {

        const create = await CreateCredit(formData);
        onClose();
        if (create.status === 200) {
          handleClose();
          CustomerCreditSuccessAlert('Crédito creado correctamente', '#1976d2');
        } else {
          handleClose();
          CustomerCreditErrorAlert('Ocurrio un error al crear el crédito', '#ff0000');
        }
      }
    } catch (err) {
      console.error('Error:', err);
      CustomerCreditErrorAlert('Ocurrió un error inesperado', '#ff0000');
    } finally {
      setLoading(false);
    }
  };
  const handleDisableCopy = (e) => {
    if ((e.ctrlKey || e.metaKey) && (e.key === 'c' || e.key === 'C')) {
      e.preventDefault();
    }
  };


  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: StyledBackdrop }}
      aria-labelledby="modal-title"
    >
      <Fade in={open}>
        <Box
          sx={{
            ...modalStyle,
            userSelect: 'none',
            WebkitUserSelect: 'none'
          }}
          onKeyDown={handleDisableCopy}
          onContextMenu={(e) => e.preventDefault()}
          onCopy={(e) => e.preventDefault()}
        >
          {loading && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                bgcolor: 'rgba(255,255,255,0.8)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10,
                borderRadius: 3,
              }}
            >
              <CircularProgress />
            </Box>
          )}

          <Grid container alignItems="center" justifyContent="space-between" mb={3}>
            <Typography id="modal-title" variant="h5" component="h2" fontWeight="bold" color="primary">
              {action === "editCredit" ? "Actualizar Crédito" : "Nuevo Crédito"}
            </Typography>
            <Button onClick={handleClose} color="error" size="large" sx={{ minWidth: 40 }}>
              X
            </Button>
          </Grid>

          <Grid container spacing={2} mb={3}>
            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                fullWidth
                label="Documento del Cliente"
                value={formData.document}
                name="document"
                variant="outlined"
                disabled
              />
              <TextField name="customer_id" value={formData.customer_id} style={{ display: 'none' }} />
              <TextField name="management_id" value={formData.management_id} style={{ display: 'none' }} />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                disabled={action === "editCredit"}
                fullWidth
                label="Nombre del Crédito"
                name="name_credit"
                value={formData.name_credit}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Fecha de inicio"
                  value={formData.start_date ? dayjs(formData.start_date) : null}
                  onChange={(newValue) => setFormData(prev => ({ ...prev, start_date: newValue }))}
                  disabled={action === "editCredit"}
                  fullWidth
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      required: true,
                    }
                  }}
                />
              </LocalizationProvider>
            </Grid>

          </Grid>

          <Grid container spacing={2} mb={3}>

            <Grid size={{ xs: 12, sm: 4 }}>
              <FormControl fullWidth>
                <InputLabel>Oficina</InputLabel>
                <Select
                  disabled={action === "editCredit"}
                  name="office_id"
                  value={formData.office_id || ''}
                  onChange={handleChange}
                  label="Oficina"
                >
                  <MenuItem value="">
                    <em>Seleccionar Oficina</em>
                  </MenuItem>

                  {offices.map((offi) => (
                    <MenuItem
                      key={offi.id_office}
                      value={offi.id_office}
                    >
                      {cities.find((city) => city.id_city === offi.city_id)?.city_name + " - " + offi.office_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <FormControl fullWidth>
                <InputLabel>Pagaduria</InputLabel>
                <Select
                  name="disbursement_office_id"
                  value={formData.disbursement_office_id || ''}
                  onChange={handleChange}
                  label="Pagaduria"
                  disabled={action === "editCredit"}
                >
                  <MenuItem value="">
                    <em>Seleccionar pagaduria</em>
                  </MenuItem>
                  {disbursementOffice.map((dof) => (
                    <MenuItem
                      key={dof.id_disbursement_office}
                      value={dof.id_disbursement_office}
                    >
                      {dof.disbursement_office}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <FormControl fullWidth>
                <InputLabel>Campaña</InputLabel>
                <Select
                  name="campaign_id"
                  value={formData.campaign_id || ''}
                  onChange={handleChange}
                  label="Campaña"
                  disabled={action === "editCredit"}
                >
                  <MenuItem value="">
                    <em>Seleccionar campaña</em>
                  </MenuItem>
                  {campaign.map((opt) => (
                    <MenuItem
                      key={opt.id_campaign}
                      value={opt.id_campaign}
                    >
                      {opt.name_campaign}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <FormControl fullWidth>
                <InputLabel>Estado Crédito</InputLabel>
                <Select
                  name="status_id"
                  value={formData.status_id || ''}
                  onChange={handleChange}
                  label="Credito Estado"
                  disabled={action === "editCredit"}
                >
                  <MenuItem value="">
                    <em>Seleccionar estado</em>
                  </MenuItem>
                  {dataType.map((opt) => (
                    <MenuItem
                      key={opt.id_type_data}
                      value={opt.id_type_data}
                    >
                      {opt.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                disabled={action === "editCredit"}
                fullWidth
                label="Monto Preaprobado"
                name="approved_amount"
                type="number"
                value={formData.approved_amount}
                onChange={handleChange}
                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                readOnly={action === "editCredit" ? true : false}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                disabled={action === "editCredit"}
                fullWidth
                label="Plazo"
                name="period"
                type="number"
                value={formData.period}
                onChange={handleChange}
                readOnly={action === "editCredit" ? true : false}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                disabled={action === "editCredit"}
                fullWidth
                label="Capacidad de Pago"
                name="payment_capacity"
                type="number"
                value={formData.payment_capacity}
                onChange={handleChange}
                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                readOnly={action === "editCredit" ? true : false}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                disabled={action === "editCredit"}
                fullWidth
                label="Saldo capital prepago"
                name="prepaid_capital_balance"
                type="number"
                value={formData.prepaid_capital_balance}
                onChange={handleChange}
                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                readOnly={action === "editCredit" ? true : false}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                disabled={action === "editCredit"}
                fullWidth
                label="Aval"
                name="aval"
                type="number"
                value={formData.aval}
                onChange={handleChange}
                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                readOnly={action === "editCredit" ? true : false}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                disabled={action === "editCredit"}
                label="Tasa interes"
                name="interest_rate"
                type="number"
                inputProps={{ max: 999.99, step: 0.01 }}
                value={formData.interest_rate}
                onChange={handleChange}
                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                readOnly={action === "editCredit" ? true : false}
                placeholder='0.1'
                fullWidth
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                disabled={action === "editCredit"}
                fullWidth
                label="Prima por Millón"
                name="prem_per_million"
                type="number"
                value={formData.prem_per_million}
                onChange={handleChange}
                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                readOnly={action === "editCredit" ? true : false}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                disabled={action === "editCredit"}
                fullWidth
                label="Estudio de Crédito"
                name="credit_study"
                type="number"
                value={formData.credit_study}
                onChange={handleChange}
                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                readOnly={action === "editCredit" ? true : false}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                disabled={action === "editCredit"}
                fullWidth
                label="Estudio"
                name="research"
                type="number"
                value={formData.research}
                onChange={handleChange}
                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                readOnly={action === "editCredit" ? true : false}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                disabled={action === "editCredit"}
                fullWidth
                label="Monto Aval"
                name="aval_amount"
                type="number"
                value={formData.aval_amount}
                onChange={handleChange}
                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                readOnly={action === "editCredit" ? true : false}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                disabled={action === "editCredit"}
                fullWidth
                label="Balance Actual"
                name="current_balance"
                type="number"
                value={formData.current_balance}
                onChange={handleChange}
                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                readOnly={action === "editCredit" ? true : false}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                disabled={action === "editCredit"}
                fullWidth
                label="Valor Desembolsado"
                name="disburse_value"
                type="number"
                value={formData.disburse_value}
                onChange={handleChange}
                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                readOnly={action === "editCredit" ? true : false}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                disabled={action === "editCredit"}
                fullWidth
                label="Valor Cuota Definida"
                name="defined_quota"
                type="number"
                value={formData.defined_quota}
                onChange={handleChange}
                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                readOnly={action === "editCredit" ? true : false}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }} >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  name="date_management"
                  label="Fecha de gestion"
                  value={formData.date_management ? dayjs(formData.date_management) : null}
                  onChange={(newValue) => setFormData(prev => ({ ...prev, date_management: newValue }))}
                  fullWidth
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      required: true,
                    }
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label="Observaciones"
                name="observation"
                value={formData.observation || ''}
                onChange={handleChange}
                multiline
                rows={3}
                placeholder="Escribe aquí cualquier observación relevante..."
              />
            </Grid>

          </Grid>

          <Stack direction="row" justifyContent="flex-end" spacing={2} mt={4}>
            <Button variant="outlined" size="large" onClick={handleClose} disabled={loading}>
              Cancelar
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={handleUpdate}
              disabled={loading}
            >
              {action === "editCredit" ? 'Actualizar' : 'Guardar'}
            </Button>
          </Stack>
        </Box>
      </Fade>
    </Modal >
  );
};

export default Credit;